import { useMemo } from 'react';
import { MapContainer, Marker, TileLayer, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import type { LatLng } from '@geoguess/shared';

const guessIcon = () =>
  L.divIcon({
    html: `<div class="guess-marker" style="background:#0a84ff"></div>`,
    className: '',
    iconSize: [26, 26],
    iconAnchor: [13, 13],
  });

function ClickCatcher({ onClick }: { onClick: (p: LatLng) => void }) {
  useMapEvents({
    click: (e) => onClick({ lat: e.latlng.lat, lng: e.latlng.lng }),
  });
  return null;
}

export function GuessMap({
  guess,
  onPick,
  disabled,
}: {
  guess: LatLng | null;
  onPick: (p: LatLng) => void;
  disabled?: boolean;
}) {
  const icon = useMemo(() => guessIcon(), []);
  return (
    <MapContainer
      center={[20, 0]}
      zoom={2}
      worldCopyJump
      className="h-full w-full"
      attributionControl={false}
    >
      <TileLayer
        url={`${window.location.protocol}//${window.location.host}/carto-tiles/dark_all/{z}/{x}/{y}.png`}
        attribution='&copy; OSM &copy; CARTO'
      />
      {!disabled && <ClickCatcher onClick={onPick} />}
      {guess && <Marker position={[guess.lat, guess.lng]} icon={icon} />}
    </MapContainer>
  );
}
